import { CompanyBasic, ReferenceStyle, Synonym } from '..';


export class Product {
  nameSelected?: string;
  active: boolean;
  isActuallyAReference?: boolean;
  id: number;
  name: string;
  companies: Array<CompanyBasic>;
  synonyms: Array<Synonym>;
  companyIds?: Array<number>;
  totals: {
    milestoneEvents: number;
    notes: number;
  };
  style: Partial<ReferenceStyle>;

  constructor (prod: Product = {} as Product) {
    this.active = prod.active || false;
    this.id = prod.id || null;
    this.name = prod.name || '';
    this.synonyms = prod.synonyms || null;
  }
}
